const pl = {
    nav: {
      home: "Strona główna",
      browse: "Przeglądaj wesela",
      dashboard: "Panel",
      messages: "Wiadomości",
      profile: "Profil",
      login: "Zaloguj się",
      register: "Zarejestruj się",
      logout: "Wyloguj się",
      admin: "Admin",
      faq: "FAQ",
      about: "O nas",
      contact: "Kontakt",
      pricing: "Cennik",
      howItWorks: "Jak to działa",
    },
    auth: {
      login: {
        title: "Witamy ponownie",
        email: "E-mail",
        password: "Hasło",
        button: "Zaloguj się",
        noAccount: "Nie masz konta?",
        register: "Zarejestruj się teraz",
      },
      register: {
        title: "Utwórz konto",
        name: "Imię i nazwisko",
        email: "E-mail",
        password: "Hasło",
        role: "Chcę...",
        roleHost: "Zorganizować wesele",
        roleGuest: "Uczestniczyć w weselach",
        terms: "Akceptuję regulamin i politykę prywatności",
        button: "Zarejestruj się",
        hasAccount: "Masz już konto?",
        login: "Zaloguj się teraz",
      },
    },
  review: {
    title: "Write a Review",
    description: "Share your experience with",
    ratingLabel: "How would you rate your experience?",
    rating1: "Poor",
    rating2: "Fair",
    rating3: "Good",
    rating4: "Very Good",
    rating5: "Excellent",
    commentLabel: "Your Review",
    optional: "optional",
    commentPlaceholder: "Tell others about your experience...",
    for: "Review for",
    submit: "Submit Review",
    success: "Review submitted successfully!",
    error: "Failed to submit review",
    selectRating: "Please select a rating",
    noReviews: "No reviews yet",
    received: "Reviews Received",
    averageRating: "Average Rating",
    writeReview: "Write Review",
    reviewed: "Reviewed",
    completedWedding: "This wedding has been completed. You can now write a review.",
  },

    common: {
      loading: "Ładowanie...",
      error: "Wystąpił błąd",
      success: "Sukces",
      save: "Zapisz",
      cancel: "Anuluj",
      delete: "Usuń",
      edit: "Edytuj",
      back: "Wstecz",
      next: "Dalej",
      language: "Język",
      currency: "Waluta",
      search: "Szukaj",
      filter: "Filtruj",
      all: "Wszystkie",
      none: "Brak",
      yes: "Tak",
      no: "Nie",
    },
    footer: {
      about: "O nas",
      privacy: "Prywatność",
      terms: "Regulamin",
      contact: "Kontakt",
      copyright: "© 2024 WEDVAYA. Wszelkie prawa zastrzeżone.",
    },
  };

export default pl;
